import { useEffect, useState } from "react";
import axios from "axios";
import { storage } from "@/lib/storage";
import { toast } from "sonner";
import { trackEvent } from "@/lib/analytics";

const EARNED = { it: ["+1 punto!", "+{n} punti!"], en: ["+1 point!", "+{n} points!"], fr: ["+1 point !", "+{n} points !"], ar: ["+1 نقطة!", "+{n} نقطة!"] };
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BADGES = [["curious", 5], ["explorer", 15], ["traveler", 40], ["gourmet", 80], ["ambassador", 150], ["sage", 300]];

export const badgesFor = (balance) => {
  const earned = BADGES.filter(([, n]) => balance >= n).map(([b]) => b);
  const next = BADGES.find(([, n]) => balance < n);
  return { earned, current: earned[earned.length - 1] || null, next: next ? { id: next[0], at: next[1] } : null };
};

export function deviceId() {
  let id = storage.get("atlas.device_id");
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36)).replace(/[^A-Za-z0-9_-]/g, "");
    storage.set("atlas.device_id", id);
  }
  return id;
}

const listeners = new Set();
let cached = Number(storage.get("atlas.points") || 0);
const publish = (b) => { cached = b; storage.set("atlas.points", String(b)); listeners.forEach((fn) => fn(b)); };

/** Fire-and-forget: credit an action (server applies points + daily caps) and toast the gain. */
export async function earnPoints(action, lang = "it") {
  try {
    const { data } = await axios.post(`${API}/points/earn`, { device_id: deviceId(), action });
    const before = badgesFor(cached).earned.length;
    publish(data.balance);
    if (data.earned) {
      trackEvent("points_earned", { action, points: data.earned });
      toast((EARNED[lang] || EARNED.en)[data.earned === 1 ? 0 : 1].replace("{n}", data.earned), { icon: "✦", duration: 2500 });
      if (badgesFor(data.balance).earned.length > before) trackEvent("badge_unlocked", { badge: badgesFor(data.balance).current });
    }
    return data;
  } catch { return { earned: 0, balance: cached }; }
}

/** Points balance + badge progress for this device. */
export default function usePoints() {
  const [balance, setBalance] = useState(cached);
  useEffect(() => {
    listeners.add(setBalance);
    axios.get(`${API}/points/${deviceId()}`).then(({ data }) => publish(data.balance)).catch(() => {});
    return () => listeners.delete(setBalance);
  }, []);
  return { balance, badges: badgesFor(balance) };
}
